<template>
    <Navbar />
    <div class="app-wrapper">
        <router-view />
        <Footer />
    </div>
    <Loader v-show="loading" />
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Loader from "@/components/Loader.vue";
import Footer from "@/components/Footer.vue";
import { emitter } from '@/services/emitter.service';

export default {
    components: {
        Navbar, Loader, Footer
    },
    data() {
        return { loading: false };
    },
    mounted() {
        if (window.top !== window.self) {
            console.warn('This application cannot be displayed in an iframe.');
            // Optionally, redirect or show a message
            window.top.location = window.location.href;
        }
    },
    created() {
        emitter.on("showLoader", (e) => {
            this.loading = e;
        });
    }
}
</script>